import React from 'react'

function Spinner(props: { className?: string; height?: string; width?: string }) {
    const { className = 'mr-2', height = '20px', width = '20px' } = props

    return (
        <div className={`flex items-center justify-center text-[#68ECF2] ${className}`}>
            <div
                style={{ width: width, height: height }}
                className={`inline-block animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]`}
                role='status'></div>
        </div>
    )
}

export default Spinner
